import { Heading4 } from 'app/components';
import { QRCodeDetails } from 'app/components/QRCode';
import { ValidateEmvResponse } from 'modules/products/interfaces/qrCode';
import Accordion from 'app/components/Accordion/Accordion';
import { QRCodeContainer, ReviewStepBox } from '../../styles';

interface ReviewStepQRCodeAccordionProps {
  qrcodeEmvValidationResponse: ValidateEmvResponse | null;
  isOpen: boolean;
  onClick: () => void;
}

const ReviewStepQRCodeAccordion = ({
  qrcodeEmvValidationResponse,
  isOpen,
  onClick,
}: ReviewStepQRCodeAccordionProps) => {
  if (!qrcodeEmvValidationResponse) {
    return null;
  }

  return (
    <ReviewStepBox marginTop="16px" marginBottom="16px" padding="24px 8px">
      <Accordion
        cleanStyle={true}
        isOpen={isOpen}
        title={<Heading4>Pix copia e cola</Heading4>}
        onClick={onClick}
      >
        <QRCodeContainer>
          <QRCodeDetails
            simulator={true}
            review={true}
            qrcodeEmvResponse={qrcodeEmvValidationResponse}
          />
        </QRCodeContainer>
      </Accordion>
    </ReviewStepBox>
  );
};

export default ReviewStepQRCodeAccordion;
